import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Car, PawPrint, Shield, Briefcase, Dumbbell, Wrench } from '../component/common/Icon';
import ROUTER_CONSTANT from '../constants/RouterConstant';
import { SHADOWS } from '../styles/theme';
import BackHeaderBar from '../component/common/HeaderBarWithBackAndName';
import { trackEvent } from '../utils/clarity';

const ITEMS = [
  {
    route: ROUTER_CONSTANT.DIRECTORY.NEIGHBOURS,
    Icon: Users,
    title: 'Neighbours',
    subtitle: 'All residents & flats',
  },
  {
    route: ROUTER_CONSTANT.DIRECTORY.VEHICLES,
    Icon: Car,
    title: 'Vehicles',
    subtitle: 'Parking & registrations',
  },
  {
    route: ROUTER_CONSTANT.DIRECTORY.PETS,
    Icon: PawPrint,
    title: 'Pets',
    subtitle: 'Society pet residents',
  },
  {
    route: ROUTER_CONSTANT.DIRECTORY.GUARDS,
    Icon: Shield,
    title: 'Guards',
    subtitle: 'Security on duty',
  },
  {
    route: ROUTER_CONSTANT.DIRECTORY.COMMITTEE,
    Icon: Briefcase,
    title: 'Committee',
    subtitle: 'Management members',
  },
  {
    route: ROUTER_CONSTANT.DIRECTORY.DAILY_HELP,
    Icon: Wrench,
    title: 'Daily Help',
    subtitle: 'Drivers, maids, cooks & more',
  },
  {
    route: ROUTER_CONSTANT.AMENITIES.ROOT,
    Icon: Dumbbell,
    title: 'Amenities',
    subtitle: 'Society facilities',
  },
];

const DirectoryPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => { trackEvent('directory_viewed'); }, []);

  return (
    <div style={{ minHeight: '100svh', background: '#f8fafc', paddingBottom: 80 }}>
      <BackHeaderBar title="Directory" backLocation={ROUTER_CONSTANT.ROOT.HOME} />

      {/* List */}
      <div style={{
        margin: '16px 16px 0',
        background: '#fff',
        borderRadius: 16,
        boxShadow: SHADOWS.card,
        overflow: 'hidden',
      }}>
        {ITEMS.map((item, i) => (
          <div
            key={item.route}
            onClick={() => navigate(item.route)}
            style={{
              display: 'flex', alignItems: 'center', gap: 14,
              padding: '14px 16px',
              cursor: 'pointer',
              borderBottom: i < ITEMS.length - 1 ? '1px solid #f3f4f6' : 'none',
            }}
          >
            <div style={{
              width: 40, height: 40, borderRadius: 12,
              background: '#f8fafc',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}>
              <item.Icon size={22} color="#4b5563" />
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ fontSize: 15, fontWeight: 600, margin: 0, color: '#111827' }}>{item.title}</p>
              <p style={{ fontSize: 12, color: '#9ca3af', margin: '1px 0 0' }}>{item.subtitle}</p>
            </div>
            <span style={{ fontSize: 18, color: '#d1d5db', flexShrink: 0 }}>›</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DirectoryPage;
